export default __webpack_public_path__ + "static/media/soheil.75acc670.svg";